import React from 'react';

function UnitRoomBox({ data }) {
    return (
        <>
            <div className="unit-room-box__header d-flex justify-content-between flex-wrap">
                <p className="unit-room-box__header-title">{data.title}</p>
                {data.area && (
                    <span
                        className="unit-room-box__header-size d-inline-block"
                        dangerouslySetInnerHTML={{ __html: data.area }}
                    />
                )}
            </div>
            <div className="unit-room-box__content d-flex flex-column">
                {data.beds && (
                    <div
                        className="unit-room-box__content-wrap d-flex flex-column"
                    >
                        {data.beds.beds.length > 0 && (
                            <div
                                className="unit-room-box__content-item d-flex align-items-center flex-wrap"
                            >
                                {data.beds.beds.map((
                                    itemBed,
                                    indexBed,
                                ) => (
                                    <div
                                        key={indexBed}
                                        className="unit-room-box__content-item-beds d-flex align-items-center"
                                    >
                                        {/* TODO: DIZAJN - Slike nisu iste boje kao na dizajnu, prokomentirati i sa backendom */}
                                        {itemBed.icon && (
                                            <>
                                                <span
                                                    className={itemBed.icon.sourceURL}
                                                    aria-hidden="true"
                                                />
                                                <span className="sr-only">{itemBed.icon.altText}</span>
                                            </>
                                        )}
                                        <span>{itemBed.title}</span>
                                    </div>
                                ))}
                            </div>
                        )}
                        <div
                            className="unit-room-box__content-item d-flex align-items-center"
                        >
                            {(data.beds.title || data.beds.totalBedsCount) && (
                                <span>
                                    {data.beds.title}:&nbsp;
                                    {data.beds.totalBedsCount}
                                </span>
                            )}
                        </div>
                    </div>
                )}
                {data.amenities?.length > 0 && (
                    <div
                        className="unit-room-box__content-wrap d-flex flex-column"
                    >
                        {data.amenities.map((
                            itemAmenities,
                            indexAmenities,
                        ) => (
                            <div
                                key={indexAmenities}
                                className="unit-room-box__content-item d-flex align-items-center"
                            >
                                {/* TODO: DIZAJN - Slike nisu iste boje kao na dizajnu, prokomentirati i sa backendom */}
                                {itemAmenities.icon && (
                                    <>
                                        <span
                                            className={itemAmenities.icon.sourceURL}
                                            aria-hidden="true"
                                        />
                                        <span className="sr-only">{itemAmenities.icon.altText}</span>
                                    </>
                                )}
                                <span className="d-inline-block">{itemAmenities.title}</span>
                            </div>
                        ))}
                    </div>
                )}
                {data.additionalInformations?.length > 0
                && data.additionalInformations.map((
                    itemAdditionalInformation,
                    indexAdditionalInformation,
                ) => (
                    <div
                        key={indexAdditionalInformation}
                        className="d-flex flex-column"
                    >
                        {itemAdditionalInformation.title && (
                            <p className="unit-room-box__content-additional-txt-header">
                                {itemAdditionalInformation.title}:
                            </p>
                        )}
                        {itemAdditionalInformation.informations?.length > 0
                        && itemAdditionalInformation.informations.map((
                            itemInformation,
                            indexInformation,
                        ) => (
                            <p className="unit-room-box__content-additional-txt" key={indexInformation}>
                                {/* TODO: DIZAJN - Pitat dizajnera jel ovde stvarno hoce navodnike kao po dizajnu(Tihanino mišljenje: nepotrebno je). */}
                                <span className="d-inline-block">{itemInformation.title}</span>
                                &nbsp;
                                <span className="d-inline-block">{itemInformation.value}</span>
                            </p>
                        ))}
                    </div>
                ))}
            </div>
        </>
    );
}

export default UnitRoomBox;
